import { makeStyles } from '@mui/styles';

const useQuestionNavigatorStyle = makeStyles(() => ({
 root: {
    height: "calc(100vh - 220px)",
    display: "flex",
    flexDirection: "column",
  },
  infoPanel: {
    paddingBottom: "8px",
    borderBottom: "1px solid #ccc",
  },
  questionGridWrapper: {
    flexGrow: 1,
    overflowY: "auto",
    marginTop: "16px",
    height: "calc(100% - 120px)", // Adjust this value based on your InfoPanel height
  },
  questionGrid: {
    flexGrow: 1,
    marginBottom: "180px",
  },
  button: {
    // minWidth: "40px",
    // minHeight: "40px",
    // borderRadius: "8px",
    // fontSize: "14px",
    // fontWeight: "bold",
    cursor:'pointer'
  },
  collapseToggle: {
    height: "60px",
    zIndex: 9,
    backgroundColor: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRight: "1px solid #ccc",
    marginTop: "200px",
  },
}));

export default useQuestionNavigatorStyle;
